export const getCategories = () => {
    const categories = Object.values(categoriesOriginal)

    const newCaategories = {};

    categories.forEach(c=>{
        newCaategories[c.id] = c;
    })

    return newCaategories;
}


export const categoriesOriginal = {
  // 1: {"id": 1, "symbol": "RE", "title": "Daily report"},
    "1": {id: 55, symbol: "AR", title: "Architecture", forBlueprint: true, order: 1},
    "2": {id: 48, symbol: "OT", title: "Other", order: 2, forBlueprint: true},
    "3": {id: 10, symbol: "WW", title: "Warranty Work", order: 3},
    "4": {id: 40, symbol: "SE", title: "Sealing", order: 4},
    "5": {id: 28, symbol: "PM", title: "Plumbing", order: 5, forBlueprint: true},
    "6": {id: 38, symbol: "AL", title: "Aluminum", order: 6, forBlueprint: true},
    "7": {id: 14, symbol: "DL", title: "Delivery", order: 7},
    "8": {id: 8, symbol: "TI", title: "Test & Inspections", order: 8},
    "9": {id: 19, symbol: "CN", title: "Concrete", order: 9},
    "59": {id: 60, symbol: "PC", title: "Precast", order: 10},
    "10": {id: 6, symbol: "SF", title: "Safety ", order: 11},
    "11": {id: 42, symbol: "EI", title: "Electrical insulation", order: 12},
    "12": {id: 49, symbol: "BU", title: "Building", order: 13, forBlueprint: true},
    "13": {id: 43, symbol: "CU", title: "Control unit", order: 14},
    "14": {id: 11, symbol: "QA", title: "QA/ QC", order: 15},
    "15": {id: 12, symbol: "RI", title: "RFI", order: 16},
    "16": {id: 21, symbol: "DW", title: "Drywall", order: 17, forBlueprint: true},
    "17": {id: 35, symbol: "RF", title: "Roofing", order: 18},
    "18": {id: 34, symbol: "GF", title: "Gates and fences", order: 19},
    "19": {id: 33, symbol: "GA", title: "Gardening", order: 20, forBlueprint: true},
    "20": {id: 9, symbol: "SI", title: "Schedule Impact", order: 21},
    "21": {id: 30, symbol: "DR", title: "Doors", order: 22, forBlueprint: true},
    "22": {id: 13, symbol: "SU", title: "Submittal", order: 23, forBlueprint: true},
    "23": {id: 45, symbol: "LA", title: "layout", order: 24, forBlueprint: true},
    "24": {id: 2, symbol: "CR", title: "Correspondense", order: 25},
    "25": {id: 50, symbol: "GL", title: "Glasses", order: 26, forBlueprint: true},
    "26": {id: 51, symbol: "ET", title: "Elavation", order: 27, forBlueprint: true},
    "27": {id: 41, symbol: "CO", title: "Covering", order: 28, forBlueprint: true},
    "28": {id: 32, symbol: "WI", title: "Windows", order: 29},
    "29": {id: 23, symbol: "EL", title: "Electrical", order: 30, forBlueprint: true},
    "30": {id: 31, symbol: "ST", title: "Stucco", order: 31},
    "31": {id: 16, symbol: "UC", title: "Unforeseen Condition", order: 32},
    "32": {id: 3, symbol: "PL", title: "Punch List", order: 33},
    "33": {id: 29, symbol: "SP", title: "Specialties", order: 34},
    "34": {id: 25, symbol: "HV", title: "HVAC", order: 35, forBlueprint: true},
    "35": {id: 52, symbol: "BL", title: "Blacksmith", order: 36, forBlueprint: true},
    "36": {id: 39, symbol: "EV", title: "Elevator", order: 37, forBlueprint: true},
    "37": {id: 17, symbol: "CA", title: "Carpentry", order: 38, forBlueprint: true},
    "38": {id: 18, symbol: "CU ", title: "Cleanup", order: 39},
    "39": {id: 7, symbol: "MM", title: "Meeting Minutes", order: 40},
    "40": {id: 20, symbol: "DE", title: "Design", order: 41},
    "41": {id: 22, symbol: "EA", title: "Earthwork", order: 42},
    "42": {id: 15, symbol: "DM", title: "Demolition", order: 43, forBlueprint: true},
    "43": {id: 53, symbol: "SD", title: "Special details", order: 44, forBlueprint: true},
    "44": {id: 47, symbol: "TL", title: "Tiling/ WC", order: 45, forBlueprint: true},
    "45": {id: 26, symbol: "PA", title: "Paint", order: 46, forBlueprint: true},
    "46": {id: 37, symbol: "GC", title: "GC", order: 47},
    "47": {id: 27, symbol: "PV", title: "Paving", order: 48, forBlueprint: true},
    "48": {id: 24, symbol: "FL", title: "Flooring", order: 49},
    "49": {id: 5, symbol: "CL", title: "Check List", order: 50},
    "50": {id: 4, symbol: "CO", title: "Change order", order: 51},
    "51": {id: 36, symbol: "SB", title: "Skeleton Building", order: 52},
    "52": {id: 44, symbol: "LI", title: "Lighting", order: 53, forBlueprint: true},
    "53": {id: 54, symbol: "RC", title: "RCP", order: 54, forBlueprint: true},
    "54": {id: 46, symbol: "CP", title: "Communication & Power", order: 55, forBlueprint: true},
    "55": {id: 1, symbol: "PN", title: "Plans", order: 56},
    "56": {id: 56, symbol: "AC", title: "Accessibility", forBlueprint: true, order: 57},
    "57": {id: 57, symbol: "SN", title: "Special Instructions", forBlueprint: true, order: 58},
    "58": {id: 58, symbol: "CS", title: "Construction", forBlueprint: true, order: 59},
    "65": {id: 65, symbol: "GS", title: "Gas systems", forBlueprint: true, order: 60},
    "60": {id: 60, symbol: "AD", title: "Area development", forBlueprint: true, order: 61},
    "61": {id: 61, symbol: "SS", title: "Site Signs", forBlueprint: true, order: 62},
    "62": {id: 62, symbol: "AT", title: "Asphalt", forBlueprint: true, order: 63},
    "63": {id: 63, symbol: "SO", title: "Site organization", forBlueprint: true, order: 64},
    "64": {id: 64, symbol: "MA", title: "Municipality approvals", forBlueprint: true, order: 65},
};

export const CATEGORIES_LIST = {
  "1": { id: 55, symbol: "AR", title: "Architecture", order: 1 },
  "2": { id: 48, symbol: "OT", title: "Other", order: 2 },
  "3": { id: 10, symbol: "WW", title: "Warranty Work", order: 3 },
  "4": { id: 40, symbol: "SE", title: "Sealing", order: 4 },
  "5": { id: 28, symbol: "PM", title: "Plumbing", order: 5 },
  "6": { id: 38, symbol: "AL", title: "Aluminum", order: 6 },
  "7": { id: 14, symbol: "DL", title: "Delivery", order: 7 },
  "8": { id: 8, symbol: "TI", title: "Test & Inspections", order: 8 },
  "9": { id: 19, symbol: "CN", title: "Concrete", order: 9 },
  "10": { id: 6, symbol: "SF", title: "Safety ", order: 10 },
  "11": { id: 42, symbol: "EI", title: "Electrical insulation", order: 11 },
  "12": { id: 49, symbol: "BU", title: "Building", order: 12 },
  "13": { id: 43, symbol: "CU", title: "Control unit", order: 13 },
  "14": { id: 11, symbol: "QA", title: "QA/ QC", order: 14 },
  "15": { id: 12, symbol: "RI", title: "RFI", order: 15 },
  "16": { id: 21, symbol: "DW", title: "Drywall", order: 16 },
  "17": { id: 35, symbol: "RF", title: "Roofing", order: 17 },
  "18": { id: 34, symbol: "GF", title: "Gates and fences", order: 18 },
  "19": { id: 33, symbol: "GA", title: "Gardening", order: 19 },
  "20": { id: 9, symbol: "SI", title: "Schedule Impact", order: 20 },
  "21": { id: 30, symbol: "DR", title: "Doors", order: 21 },
  "22": { id: 13, symbol: "SU", title: "Submittal", order: 22 },
  "23": { id: 45, symbol: "LA", title: "layout", order: 23 },
  "24": { id: 2, symbol: "CR", title: "Correspondense", order: 24 },
  "25": { id: 50, symbol: "GL", title: "Glasses", order: 25 },
  "26": { id: 51, symbol: "ET", title: "Elavation", order: 26 },
  "27": { id: 41, symbol: "CO", title: "Covering", order: 27 },
  "28": { id: 32, symbol: "WI", title: "Windows", order: 28 },
  "29": { id: 23, symbol: "EL", title: "Electrical", order: 29 },
  "30": { id: 31, symbol: "ST", title: "Stucco", order: 30 },
  "31": { id: 16, symbol: "UC", title: "Unforeseen Condition", order: 31 },
  "32": { id: 3, symbol: "PL", title: "Punch List", order: 32 },
  "33": { id: 29, symbol: "SP", title: "Specialties ", order: 33 },
  "34": { id: 25, symbol: "HV", title: "HVAC", order: 34 },
  "35": { id: 52, symbol: "BL", title: "Blacksmith", order: 35 },
  "36": { id: 39, symbol: "EV", title: "Elevator", order: 36 },
  "37": { id: 17, symbol: "CA", title: "Carpentry", order: 37 },
  "38": { id: 18, symbol: "CU ", title: "Cleanup", order: 38 },
  "39": { id: 7, symbol: "MM", title: "Meeting Minutes", order: 39 },
  "40": { id: 20, symbol: "DE", title: "Design", order: 40 },
  "41": { id: 22, symbol: "EA", title: "Earthwork", order: 41 },
  "42": { id: 15, symbol: "DM", title: "Demolition", order: 42 },
  "43": { id: 53, symbol: "SD", title: "Special details", order: 43 },
  "44": { id: 47, symbol: "TL", title: "Tiling/WC", order: 44 },
  "45": { id: 26, symbol: "PA", title: "Paint", order: 45 },
  "46": { id: 37, symbol: "GC", title: "GC", order: 46 },
  "47": { id: 27, symbol: "PV", title: "Paving", order: 47 },
  "48": { id: 24, symbol: "FL", title: "Flooring", order: 48 },
  "49": { id: 5, symbol: "CL", title: "Check List", order: 49 },
  "50": { id: 4, symbol: "CO", title: "Change order", order: 50 },
  "51": { id: 36, symbol: "SB", title: "Skeleton Building", order: 51 },
  "52": { id: 44, symbol: "LI", title: "Lighting", order: 52 },
  "53": { id: 54, symbol: "RC", title: "RCP", order: 53 },
  "54": { id: 46, symbol: "CP", title: "Communication & Power", order: 54 },
  "55": { id: 1, symbol: "PN", title: "Plans", order: 55 },
  "56": { id: 56, symbol: "AC", title: "Accessibility", order: 56 },
  "57": { id: 57, symbol: "SN", title: "Special Instructions", order: 57 },
  "58": { id: 58, symbol: "CS", title: "Construction", order: 58 }
};

export const heCategoriesOriginal = {
  // 1: {"id": 1, "symbol": "RE", "title": "דוח יומי"},
  1: { id: 1, symbol: "PN", title: "תוכניות" },
  2: { id: 2, symbol: "CR", title: "התכתבות" },
  3: { id: 3, symbol: "PL", title: "ליקויים" },
  4: { id: 4, symbol: "CO", title: "שינויים" },
  5: { id: 5, symbol: "CL", title: "רשימת בדיקות" },
  6: { id: 6, symbol: "SF", title: "בטיחות" },
  7: { id: 7, symbol: "MM", title: "סכום פגישה" },
  8: { id: 8, symbol: "TI", title: "בדיקות" },
  9: { id: 9, symbol: "SI", title: "דחיות" },
  10: { id: 10, symbol: "WW", title: "אחריות" },
  11: { id: 11, symbol: "QA", title: "בקרת איכות" },
  12: { id: 12, symbol: "RI", title: "RFI" },
  13: { id: 13, symbol: "SU", title: "הגשות" },
  14: { id: 14, symbol: "DL", title: "אספקה" },
  15: { id: 15, symbol: "DM", title: "פינוי" },
  16: { id: 16, symbol: "UC", title: "לא צפוי" },
  17: { id: 17, symbol: "CA", title: "נגרות" },
  18: { id: 18, symbol: "CU ", title: "נקיונות" },
  19: { id: 19, symbol: "CN", title: "בטון" },
  20: { id: 20, symbol: "DE", title: "עיצוב" },
  21: { id: 21, symbol: "DW", title: "גבס" },
  22: { id: 22, symbol: "EA", title: "עפר" },
  23: { id: 23, symbol: "EL", title: "חשמל" },
  24: { id: 24, symbol: "FL", title: "רצפה" },
  25: { id: 25, symbol: "HV", title: "מיזוג" },
  26: { id: 26, symbol: "PA", title: "צביעה" },
  27: { id: 27, symbol: "PV", title: "ריצוף" },
  28: { id: 28, symbol: "PM", title: "אינסטלציה" },
  29: { id: 29, symbol: "SP", title: "מומחים" },
  30: { id: 30, symbol: "DR", title: "דלתות" },
  31: { id: 31, symbol: "ST", title: "טיח" },
  32: { id: 32, symbol: "WI", title: "חלונות" },
  33: { id: 33, symbol: "GA", title: "גינון" },
  34: { id: 34, symbol: "GF", title: "גדרות" },
  35: { id: 35, symbol: "RF", title: "גגות" },
  36: { id: 36, symbol: "SB", title: "שלד​" },
  37: { id: 37, symbol: "GC", title: "קבלן גמר​" },
  38: { id: 38, symbol: "AL", title: "אלומיניום​" },
  39: { id: 39, symbol: "EV", title: "מעלית​" },
  40: { id: 40, symbol: "SE", title: "איטום" },
  41: { id: 41, symbol: "CO", title: "חיפויים" },
  42: { id: 42, symbol: "EI", title: "בידוד" },
  43: { id: 43, symbol: "CU", title: "בקרה" },
  44: { id: 44, symbol: "LI", title: "תאורה" },
  45: { id: 45, symbol: "LA", title: "העמדה" },
  46: { id: 46, symbol: "CP", title: "תקשורת וכח" },
  47: { id: 47, symbol: "TL", title: "פריסות" },
  48: { id: 48, symbol: "OT", title: "אחר" },
  49: { id: 49, symbol: "BU", title: "בניה" },
  50: { id: 50, symbol: "GL", title: "זכוכית" },
  51: { id: 51, symbol: "ET", title: "חזיתות" },
  52: { id: 52, symbol: "BL", title: "מסגרות" },
  53: { id: 53, symbol: "SD", title: "פריטים ניוחדים" },
  54: { id: 54, symbol: "RC", title: "תקרה" },
  55: { id: 55, symbol: "AR", title: "אדריכלות" },
  56: { id: 56, symbol: "AC", title: "נגישות" },
  57: { id: 57, symbol: "SN", title: "פיקוד העורף" },
  58: { id: 58, symbol: "CS", title: "קונסטרוקציה" }
};

export const CATEGORIES_LIST_HE = {
    "1": {id: 55, symbol: "AR", title: "אדריכלות", forBlueprint: true, order: 1},
    "2": {id: 48, symbol: "OT", title: "אחר", order: 2, forBlueprint: true},
    "3": {id: 10, symbol: "WW", title: "אחריות", order: 3},
    "4": {id: 40, symbol: "SE", title: "איטום", order: 4},
    "5": {id: 28, symbol: "PM", title: "אינסטלציה", order: 5, forBlueprint: true},
    "6": {id: 38, symbol: "AL", title: "אלומיניום​", order: 6, forBlueprint: true},
    "7": {id: 14, symbol: "DL", title: "אספקה וציוד", order: 7},
    "8": {id: 8, symbol: "TI", title: "בדיקות", order: 8},
    "9": {id: 19, symbol: "CN", title: "בטון", order: 9},
    "59": {id: 19, symbol: "PC", title: "בטון טרום", order: 10},
    "10": {id: 6, symbol: "SF", title: "בטיחות ", order: 11},
    "11": {id: 42, symbol: "EI", title: "בידוד", order: 12},
    "12": {id: 49, symbol: "BU", title: "בניה", order: 13, forBlueprint: true},
    "13": {id: 43, symbol: "CU", title: "בקרה", order: 14},
    "14": {id: 11, symbol: "QA", title: "בקרת איכות", order: 15},
    "15": {id: 12, symbol: "RI", title: "RFI", order: 16},
    "16": {id: 21, symbol: "DW", title: "גבס", order: 17, forBlueprint: true},
    "17": {id: 35, symbol: "RF", title: "גגות", order: 18},
    "18": {id: 34, symbol: "GF", title: "גדרות", order: 19},
    "19": {id: 33, symbol: "GA", title: "גינון", order: 20, forBlueprint: true},
    "20": {id: 9, symbol: "SI", title: "דחיות", order: 21},
    "21": {id: 30, symbol: "DR", title: "דלתות", order: 22, forBlueprint: true},
    "22": {id: 13, symbol: "SU", title: "הגשות", order: 23, forBlueprint: true},
    "23": {id: 45, symbol: "LA", title: "העמדה", order: 24, forBlueprint: true},
    "24": {id: 2, symbol: "CR", title: "התכתבות", order: 25},
    "25": {id: 50, symbol: "GL", title: "זכוכית", order: 26, forBlueprint: true},
    "26": {id: 51, symbol: "ET", title: "חזיתות", order: 27, forBlueprint: true},
    "27": {id: 41, symbol: "CO", title: "חיפויים", order: 28, forBlueprint: true},
    "28": {id: 32, symbol: "WI", title: "חלונות", order: 29},
    "29": {id: 23, symbol: "EL", title: "חשמל", order: 30, forBlueprint: true},
    "30": {id: 31, symbol: "ST", title: "טיח", order: 31},
    "31": {id: 16, symbol: "UC", title: "לא צפוי", order: 32},
    "32": {id: 3, symbol: "PL", title: "ליקויים", order: 33},
    "33": {id: 29, symbol: "SP", title: "מומחים", order: 34},
    "34": {id: 25, symbol: "HV", title: "מיזוג", order: 35, forBlueprint: true},
    "35": {id: 52, symbol: "BL", title: "מסגרות", order: 36, forBlueprint: true},
    "36": {id: 39, symbol: "EV", title: "מעלית​", order: 37, forBlueprint: true},
    "37": {id: 17, symbol: "CA", title: "נגרות", order: 38, forBlueprint: true},
    "38": {id: 18, symbol: "CU ", title: "נקיונות", order: 39},
    "39": {id: 7, symbol: "MM", title: "סכום פגישה", order: 40},
    "40": {id: 20, symbol: "DE", title: "עיצוב", order: 41},
    "41": {id: 22, symbol: "EA", title: "עפר", order: 42},
    "42": {id: 15, symbol: "DM", title: "פינוי", order: 43, forBlueprint: true},
    "43": {id: 53, symbol: "SD", title: "פריטים מיוחדים", order: 44, forBlueprint: true},
    "44": {id: 47, symbol: "TL", title: "פריסות", order: 45, forBlueprint: true},
    "45": {id: 26, symbol: "PA", title: "צביעה", order: 46, forBlueprint: true},
    "46": {id: 37, symbol: "GC", title: "קבלן גמר", order: 47},
    "47": {id: 27, symbol: "PV", title: "ריצוף", order: 48, forBlueprint: true},
    "48": {id: 24, symbol: "FL", title: "רצפה", order: 49},
    "49": {id: 5, symbol: "CL", title: "רשימת בדיקות", order: 50},
    "50": {id: 4, symbol: "CO", title: "שינויים", order: 51},
    "51": {id: 36, symbol: "SB", title: "שלד​", order: 52},
    "52": {id: 44, symbol: "LI", title: "תאורה", order: 53, forBlueprint: true},
    "53": {id: 54, symbol: "RC", title: "תקרה", order: 54, forBlueprint: true},
    "54": {id: 46, symbol: "CP", title: "תקשורת וכח", order: 55, forBlueprint: true},
    "55": {id: 1, symbol: "PN", title: "תוכניות", order: 56},
    "56": {id: 56, symbol: "AC", title: "נגישות", forBlueprint: true, order: 57},
    "57": {id: 57, symbol: "SN", title: "פיקוד העורף", forBlueprint: true, order: 58},
    "58": {id: 58, symbol: "CS", title: "קונסטרוקציה", forBlueprint: true, order: 59},
    "65": {id: 65, symbol: "GS", title: "מערכות גז", forBlueprint: true, order: 60},
    "60": {id: 60, symbol: "AD", title: "פיתוח חוץ", forBlueprint: true, order: 61},
    "61": {id: 61, symbol: "SS", title: "תמרור ושילוט", forBlueprint: true, order: 62},
    "62": {id: 62, symbol: "AT", title: "אספלט", forBlueprint: true, order: 63},
    "63": {id: 63, symbol: "SO", title: "ארגון אתר", forBlueprint: true, order: 64},
    "64": {id: 64, symbol: "MA", title: "טופס 4", forBlueprint: true, order: 65},
};

const for_bluprint_id = [
  48,
  28,
  38,
  49,
  21,
  33,
  30,
  13,
  45,
  50,
  51,
  41,
  23,
  25,
  52,
  39,
  17,
  15,
  53,
  47,
  26,
  27,
  44,
  54,
  46,
  55,
  56,
  57,
  58
];
export const heCategories = {
    "1": {"id": 1, "symbol": "PN", "title": "תוכניות", "order": 56},
    "2": {"id": 2, "symbol": "CR", "title": "התכתבות", "order": 25},
    "3": {"id": 3, "symbol": "PL", "title": "ליקויים", "order": 33},
    "4": {"id": 4, "symbol": "CO", "title": "שינויים", "order": 51},
    "5": {"id": 5, "symbol": "CL", "title": "רשימת בדיקות", "order": 50},
    "6": {"id": 6, "symbol": "SF", "title": "בטיחות ", "order": 11},
    "7": {"id": 7, "symbol": "MM", "title": "סכום פגישה", "order": 40},
    "8": {"id": 8, "symbol": "TI", "title": "בדיקות", "order": 8},
    "9": {"id": 9, "symbol": "SI", "title": "דחיות", "order": 21},
    "10": {"id": 10, "symbol": "WW", "title": "אחריות", "order": 3},
    "11": {"id": 11, "symbol": "QA", "title": "בקרת איכות", "order": 15},
    "12": {"id": 12, "symbol": "RI", "title": "RFI", "order": 16},
    "13": {"id": 13, "symbol": "SU", "title": "הגשות", "order": 23, "forBlueprint": true},
    "14": {"id": 14, "symbol": "DL", "title": "אספקה וציוד", "order": 7},
    "15": {"id": 15, "symbol": "DM", "title": "פינוי", "order": 43, "forBlueprint": true},
    "16": {"id": 16, "symbol": "UC", "title": "לא צפוי", "order": 32},
    "17": {"id": 17, "symbol": "CA", "title": "נגרות", "order": 38, "forBlueprint": true},
    "18": {"id": 18, "symbol": "CU ", "title": "נקיונות", "order": 39},
    "19": {"id": 19, "symbol": "PC", "title": "בטון טרום", "order": 10},
    "20": {"id": 20, "symbol": "DE", "title": "עיצוב", "order": 41},
    "21": {"id": 21, "symbol": "DW", "title": "גבס", "order": 17, "forBlueprint": true},
    "22": {"id": 22, "symbol": "EA", "title": "עפר", "order": 42},
    "23": {"id": 23, "symbol": "EL", "title": "חשמל", "order": 30, "forBlueprint": true},
    "24": {"id": 24, "symbol": "FL", "title": "רצפה", "order": 49},
    "25": {"id": 25, "symbol": "HV", "title": "מיזוג", "order": 35, "forBlueprint": true},
    "26": {"id": 26, "symbol": "PA", "title": "צביעה", "order": 46, "forBlueprint": true},
    "27": {"id": 27, "symbol": "PV", "title": "ריצוף", "order": 48, "forBlueprint": true},
    "28": {"id": 28, "symbol": "PM", "title": "אינסטלציה", "order": 5, "forBlueprint": true},
    "29": {"id": 29, "symbol": "SP", "title": "מומחים", "order": 34},
    "30": {"id": 30, "symbol": "DR", "title": "דלתות", "order": 22, "forBlueprint": true},
    "31": {"id": 31, "symbol": "ST", "title": "טיח", "order": 31},
    "32": {"id": 32, "symbol": "WI", "title": "חלונות", "order": 29},
    "33": {"id": 33, "symbol": "GA", "title": "גינון", "order": 20, "forBlueprint": true},
    "34": {"id": 34, "symbol": "GF", "title": "גדרות", "order": 19},
    "35": {"id": 35, "symbol": "RF", "title": "גגות", "order": 18},
    "36": {"id": 36, "symbol": "SB", "title": "שלד​", "order": 52},
    "37": {"id": 37, "symbol": "GC", "title": "קבלן גמר", "order": 47},
    "38": {"id": 38, "symbol": "AL", "title": "אלומיניום​", "order": 6, "forBlueprint": true},
    "39": {"id": 39, "symbol": "EV", "title": "מעלית​", "order": 37, "forBlueprint": true},
    "40": {"id": 40, "symbol": "SE", "title": "איטום", "order": 4},
    "41": {"id": 41, "symbol": "CO", "title": "חיפויים", "order": 28, "forBlueprint": true},
    "42": {"id": 42, "symbol": "EI", "title": "בידוד", "order": 12},
    "43": {"id": 43, "symbol": "CU", "title": "בקרה", "order": 14},
    "44": {"id": 44, "symbol": "LI", "title": "תאורה", "order": 53, "forBlueprint": true},
    "45": {"id": 45, "symbol": "LA", "title": "העמדה", "order": 24, "forBlueprint": true},
    "46": {"id": 46, "symbol": "CP", "title": "תקשורת וכח", "order": 55, "forBlueprint": true},
    "47": {"id": 47, "symbol": "TL", "title": "פריסות", "order": 45, "forBlueprint": true},
    "48": {"id": 48, "symbol": "OT", "title": "אחר", "order": 2, "forBlueprint": true},
    "49": {"id": 49, "symbol": "BU", "title": "בניה", "order": 13, "forBlueprint": true},
    "50": {"id": 50, "symbol": "GL", "title": "זכוכית", "order": 26, "forBlueprint": true},
    "51": {"id": 51, "symbol": "ET", "title": "חזיתות", "order": 27, "forBlueprint": true},
    "52": {"id": 52, "symbol": "BL", "title": "מסגרות", "order": 36, "forBlueprint": true},
    "53": {"id": 53, "symbol": "SD", "title": "פריטים מיוחדים", "order": 44, "forBlueprint": true},
    "54": {"id": 54, "symbol": "RC", "title": "תקרה", "order": 54, "forBlueprint": true},
    "55": {"id": 55, "symbol": "AR", "title": "אדריכלות", "forBlueprint": true, "order": 1},
    "56": {"id": 56, "symbol": "AC", "title": "נגישות", "forBlueprint": true, "order": 57},
    "57": {"id": 57, "symbol": "SN", "title": "פיקוד העורף", "forBlueprint": true, "order": 58},
    "58": {"id": 58, "symbol": "CS", "title": "קונסטרוקציה", "forBlueprint": true, "order": 59},
    "60": {"id": 60, "symbol": "AD", "title": "פיתוח חוץ", "forBlueprint": true, "order": 61},
    "61": {"id": 61, "symbol": "SS", "title": "תמרור ושילוט", "forBlueprint": true, "order": 62},
    "62": {"id": 62, "symbol": "AT", "title": "אספלט", "forBlueprint": true, "order": 63},
    "63": {"id": 63, "symbol": "SO", "title": "ארגון אתר", "forBlueprint": true, "order": 64},
    "64": {"id": 64, "symbol": "MA", "title": "טופס 4", "forBlueprint": true, "order": 65},
    "65": {"id": 65, "symbol": "GS", "title": "מערכות גז", "forBlueprint": true, "order": 60}
};

export const categories = {
    "1": {id: 55, symbol: "AR", title: "Architecture", forBlueprint: true, order: 1},
    "2": {id: 48, symbol: "OT", title: "Other", order: 2, forBlueprint: true},
    "3": {id: 10, symbol: "WW", title: "Warranty Work", order: 3},
    "4": {id: 40, symbol: "SE", title: "Sealing", order: 4},
    "5": {id: 28, symbol: "PM", title: "Plumbing", order: 5, forBlueprint: true},
    "6": {id: 38, symbol: "AL", title: "Aluminum", order: 6, forBlueprint: true},
    "7": {id: 14, symbol: "DL", title: "Delivery", order: 7},
    "8": {id: 8, symbol: "TI", title: "Test & Inspections", order: 8},
    "9": {id: 19, symbol: "CN", title: "Concrete", order: 9},
    "10": {id: 6, symbol: "SF", title: "Safety ", order: 10},
    "11": {id: 42, symbol: "EI", title: "Electrical insulation", order: 11},
    "12": {id: 49, symbol: "BU", title: "Building", order: 12, forBlueprint: true},
    "13": {id: 43, symbol: "CU", title: "Control unit", order: 13},
    "14": {id: 11, symbol: "QA", title: "QA/ QC", order: 14},
    "15": {id: 12, symbol: "RI", title: "RFI", order: 15},
    "16": {id: 21, symbol: "DW", title: "Drywall", order: 16, forBlueprint: true},
    "17": {id: 35, symbol: "RF", title: "Roofing", order: 17},
    "18": {id: 34, symbol: "GF", title: "Gates and fences", order: 18},
    "19": {id: 33, symbol: "GA", title: "Gardening", order: 19, forBlueprint: true},
    "20": {id: 9, symbol: "SI", title: "Schedule Impact", order: 20},
    "21": {id: 30, symbol: "DR", title: "Doors", order: 21, forBlueprint: true},
    "22": {id: 13, symbol: "SU", title: "Submittal", order: 22, forBlueprint: true},
    "23": {id: 45, symbol: "LA", title: "layout", order: 23, forBlueprint: true},
    "24": {id: 2, symbol: "CR", title: "Correspondense", order: 24},
    "25": {id: 50, symbol: "GL", title: "Glasses", order: 25, forBlueprint: true},
    "26": {id: 51, symbol: "ET", title: "Elavation", order: 26, forBlueprint: true},
    "27": {id: 41, symbol: "CO", title: "Covering", order: 27, forBlueprint: true},
    "28": {id: 32, symbol: "WI", title: "Windows", order: 28},
    "29": {id: 23, symbol: "EL", title: "Electrical", order: 29, forBlueprint: true},
    "30": {id: 31, symbol: "ST", title: "Stucco", order: 30},
    "31": {id: 16, symbol: "UC", title: "Unforeseen Condition", order: 31},
    "32": {id: 3, symbol: "PL", title: "Punch List", order: 32},
    "33": {id: 29, symbol: "SP", title: "Specialties", order: 33},
    "34": {id: 25, symbol: "HV", title: "HVAC", order: 34, forBlueprint: true},
    "35": {id: 52, symbol: "BL", title: "Blacksmith", order: 35, forBlueprint: true},
    "36": {id: 39, symbol: "EV", title: "Elevator", order: 36, forBlueprint: true},
    "37": {id: 17, symbol: "CA", title: "Carpentry", order: 37, forBlueprint: true},
    "38": {id: 18, symbol: "CU ", title: "Cleanup", order: 38},
    "39": {id: 7, symbol: "MM", title: "Meeting Minutes", order: 39},
    "40": {id: 20, symbol: "DE", title: "Design", order: 40},
    "41": {id: 22, symbol: "EA", title: "Earthwork", order: 41},
    "42": {id: 15, symbol: "DM", title: "Demolition", order: 42, forBlueprint: true},
    "43": {id: 53, symbol: "SD", title: "Special details", order: 43, forBlueprint: true},
    "44": {id: 47, symbol: "TL", title: "Tiling/ WC", order: 44, forBlueprint: true},
    "45": {id: 26, symbol: "PA", title: "Paint", order: 45, forBlueprint: true},
    "46": {id: 37, symbol: "GC", title: "GC", order: 46},
    "47": {id: 27, symbol: "PV", title: "Paving", order: 47, forBlueprint: true},
    "48": {id: 24, symbol: "FL", title: "Flooring", order: 48},
    "49": {id: 5, symbol: "CL", title: "Check List", order: 49},
    "50": {id: 4, symbol: "CO", title: "Change order", order: 50},
    "51": {id: 36, symbol: "SB", title: "Skeleton Building", order: 51},
    "52": {id: 44, symbol: "LI", title: "Lighting", order: 52, forBlueprint: true},
    "53": {id: 54, symbol: "RC", title: "RCP", order: 53, forBlueprint: true},
    "54": {id: 46, symbol: "CP", title: "Communication & Power", order: 54, forBlueprint: true},
    "55": {id: 1, symbol: "PN", title: "Plans", order: 55},
    "56": {id: 56, symbol: "AC", title: "Accessibility", forBlueprint: true, order: 56},
    "57": {id: 57, symbol: "SN", title: "Special Instructions", forBlueprint: true, order: 57},
    "58": {id: 58, symbol: "CS", title: "Construction", forBlueprint: true, order: 58}
};
